module.exports = __webpack_public_path__ + "static/busstop-04501a63f58ba687f4653e308f233c35.png";